import { useEffect, useState } from "react";
import CmsService from "../../../service/CmsService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";

export function QueReviews({id}){
    const {t}=useTranslation();
    const [revs,setRevs]=useState([]);
    useEffect(()=>{
        if(id==undefined || id==0)
            return;
        CmsService.getQuestionReviews(id).then((ret)=>{
            setRevs(ret);
        });
    },[]);
    return(
        <div className="grid m-0 mt-2">
            <DataTable value={revs} className="p-datatable-striped p-datatable-sm w-full">
                <Column field="actDate" header={t("Date-time")} style={{width:'20%'}} sortable
                    body={(rev)=>t('datetime.short',{val:rev.actDate})}></Column>
                <Column field="review.status" header={t("Status")} style={{width:'20%'}} sortable></Column>
                <Column field="review.message" header={t("Message")} style={{width:'20%'}} sortable></Column>
                <Column field="userName" header={t("User")} style={{width:'20%'}} sortable></Column>
            </DataTable>
        </div>
    )
}